// @ts-strict-ignore
import { Component, Input } from '@angular/core';
import { LMCubeCellRelTestResult } from './lm-cube-cell-rel';
import { LMCubeCellRelService } from './services';
import { LMErrorUtilService } from '@services/utils';
import { LMMeasure } from '@modal/cubes/lm-cubes';

@Component({
  selector:    'lm-cube-cell-rel-test',
  templateUrl: './lm-cube-cell-rel-test.component.html',
})

export class LMCubeCellRelTestComponent {
  @Input() busClass: string;
  @Input() busClassTotalName: string;
  @Input() measures: Array<LMMeasure>;

  public measure: string;
  public testResult: string;

  constructor(
    private lmCubeCellRelService: LMCubeCellRelService,
    private lmErrorUtilService: LMErrorUtilService,
  ) {}

  public testMeasure() {
    if (!this.measures) {
      return;
    }
    this.lmCubeCellRelService.testMeasure(this.busClass, this.busClassTotalName, this.measure)
      .subscribe((response: LMCubeCellRelTestResult) => {
        if (response.error) {
          this.lmErrorUtilService.handleError(response.error);
          return;
        }
        this.testResult = response.value;
      });
  }
}
